function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 299.256 69.038",
    style: {
      enableBackground: "new 0 0 299.256 69.038"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56a821"
    },
    d: "M77.106 58.6s200.17 0 190.48 1.28c-.79.1-149.12.77-185.67 3.84-2.21.18-4.81-5.12-4.81-5.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56a821"
    },
    d: "M104.936 55.53h3.91l-1.93-31h-5.11l-5.53 15c-1.38 3.91-2.48 7.32-3.27 10.45h-.13c-.79-3.22-1.84-6.63-3.13-10.45l-5.3-15h-5.11l-2.16 31h3.82l.83-13.3c.27-4.65.5-9.86.6-13.72h.09c.87 3.68 2.12 7.68 3.59 12.06l5 14.78h3l5.47-15.06c1.57-4.28 2.86-8.15 3.92-11.78h.14c-.05 3.86.23 9.07.46 13.39l.84 13.63zm5.9-22.28 8.27 20.53c.143.338.234.695.27 1.06-.047.35-.155.688-.32 1a12.28 12.28 0 0 1-3.41 4.51 10.688 10.688 0 0 1-3.54 2l1 3.41a11.069 11.069 0 0 0 5-2.63c2.76-2.39 4.74-6.31 7.64-14l6.08-15.88h-4.32l-4.4 13.07c-.55 1.61-1 3.32-1.43 4.65h-.09c-.37-1.33-.92-3.08-1.43-4.55l-4.88-13.17h-4.44zm27.74 22.28V42.27c0-5.15-.09-8.88-.32-12.8h.14a98.922 98.922 0 0 0 5.8 10.36l9.85 15.74h4.06v-31h-3.77v13c0 4.84.09 8.61.46 12.76h-.09a89.984 89.984 0 0 0-5.6-10.13l-10-15.7h-4.3v31l3.77.03zm43.2-10.4c.088-.626.134-1.258.14-1.89 0-4.1-1.93-10.5-9.21-10.5-6.49 0-10.45 5.3-10.45 12s4.1 11.23 11 11.23a18.151 18.151 0 0 0 7.41-1.38l-.69-2.9a14.738 14.738 0 0 1-6.17 1.15c-4 0-7.55-2.26-7.64-7.73l15.61.02zm-15.6-2.9c.32-2.81 2.11-6.59 6.21-6.59 4.56 0 5.66 4 5.62 6.59h-11.83zm21-14.32v5.34h-3.45v3.08h3.45v12.16c0 2.62.41 4.6 1.56 5.8a5.65 5.65 0 0 0 4.37 1.71c1.22.037 2.437-.149 3.59-.55l-.18-3a8.95 8.95 0 0 1-2.35.28c-2.26 0-3-1.57-3-4.33v-12h5.8v-3.15h-5.8v-6.4l-3.99 1.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d7e06"
    },
    d: "M200.026 55.44c2.539.294 5.094.431 7.65.41 6 0 11-1.42 14-4.23 2.94-2.67 4.83-6.82 4.83-12.34 0-5.3-1.84-9-4.83-11.42s-6.86-3.59-12.66-3.59a57.928 57.928 0 0 0-9 .64l.01 30.53zm5.67-26.44a18.376 18.376 0 0 1 3.86-.32c7.09 0 11.05 3.91 11 10.77 0 7.88-4.38 11.93-11.74 11.88a20.85 20.85 0 0 1-3.13-.14l.01-22.19zm30.09 26.52V33.11h-5.68v22.42l5.68-.01zm-2.85-31.77a3 3 0 0 0-3.18 3.09 3.18 3.18 0 0 0 6.36 0 3 3 0 0 0-3.18-3.08v-.01zm25.4 31.77a36.114 36.114 0 0 1-.32-5.39V42c0-4.88-2.08-9.44-9.26-9.44a16.184 16.184 0 0 0-8.1 2l1.1 3.69a11.877 11.877 0 0 1 6-1.66c3.95 0 4.55 2.44 4.55 3.91v.37c-8.28 0-13.3 2.81-13.3 8.47a6.65 6.65 0 0 0 7.1 6.66 8.329 8.329 0 0 0 6.63-3h.14l.37 2.49 5.09.03zm-5.85-7.87c.006.42-.055.839-.18 1.24a4.601 4.601 0 0 1-4.42 3.11 3 3 0 0 1-3.23-3.23c0-3.4 3.83-4.28 7.83-4.19v3.07zm10.41 7.87h5.66V43.93c.006-.588.07-1.174.19-1.75a5 5 0 0 1 5.06-4.28 8.129 8.129 0 0 1 1.66.18v-5.34a6.158 6.158 0 0 0-1.36-.14 6.682 6.682 0 0 0-6.12 4.79h-.19l-.18-4.28h-4.91c.14 2 .19 4.19.19 7.23v15.18zm13.94-22.42 8.2 20.58c.192.336.302.713.32 1.1-.044.358-.17.7-.37 1a9.802 9.802 0 0 1-3.08 3.54 9.687 9.687 0 0 1-3.32 1.57l1.29 4.79a11.507 11.507 0 0 0 5.94-2.9c2.67-2.31 4.74-6 7.83-14.42l5.61-15.28h-6.07l-3.5 12c-.42 1.47-.83 3.13-1.2 4.42h-.14c-.32-1.29-.78-3-1.24-4.37l-4.05-12-6.22-.03z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 29.202,
    y1: 12.962,
    x2: 29.202,
    y2: 67.042,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#81c218"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a8de0a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#a)"
    },
    d: "M41.956 33.78a118.21 118.21 0 0 1-40.66 10.55h-.74c-.11-.85-.21-1.73-.25-2.63 0 0-2.22-22.15 13.33-25.83 0 0 4.66-1.7 10.21 1.62a14.993 14.993 0 0 0 5 1.42 11.351 11.351 0 0 0 5.87-.91h-.08c.66-.26 1.08-.46 1.08-.46 5.57-3.32 10.21-1.6 10.21-1.6A15.5 15.5 0 0 1 56.606 25l-.68.58a76.585 76.585 0 0 1-13.97 8.2zm1 22.13a74.874 74.874 0 0 0 15.25-7.74 33.002 33.002 0 0 1-14.66 19.35c-4.34 2.8-9.86.87-9.86.87a39.556 39.556 0 0 0-4-.85 40.071 40.071 0 0 0-4 .84s-5.54 1.92-9.86-.89a30.214 30.214 0 0 1-6-4.73 110.887 110.887 0 0 0 33.13-6.85z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 38.639,
    x2: 61.176,
    y2: 38.639,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#eaeae5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#eaeae5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#b)"
    },
    d: "M60.746 44.66c-14.47 10.84-34 15.5-51.71 16.71a.89.89 0 0 1-.79-.36c-1.27-1.68-6.14-8.36-8.14-13.72-.28-.74 0-1.26.75-1.93-.22.32-.35.92.2.86 17.68-1.94 40.23-7.32 56.17-19.38a.83.83 0 0 0-.21-1.49s1.58 0 2.06.86 2.03 11.62 2.1 17.59c.001.339-.158.658-.43.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#83898c"
    },
    d: "m8.316 49.31-1 .2-1.21 1.07.5 1 .79-.66 1.1 4.49 1.24-.25-1.42-5.85zm15.26 2-2 .56c.8-1.35 1.39-2.48 1.09-3.6a1.81 1.81 0 0 0-1.91-1.4c-.169.013-.336.04-.5.08a2.75 2.75 0 0 0-1.59 1.05l-.11.16.72.88.2-.29c.213-.31.522-.542.88-.66a.74.74 0 0 1 1 .58c.18.7-.21 1.51-1.23 3.18l-.48.81.22.74 4-1-.29-1.09zm12.59-4.06a1.65 1.65 0 0 0-1.3-1.15 1.56 1.56 0 0 0-1.28-2.52c-.252 0-.503.044-.74.13a2.941 2.941 0 0 0-1.41 1l-.11.16.69.9.21-.28c.208-.279.493-.491.82-.61.11-.037.224-.057.34-.06a.53.53 0 0 1 .53.4c.06.2.011.416-.13.57a1.32 1.32 0 0 1-.6.38l-.66.21.34 1.05.65-.21c.189-.072.388-.112.59-.12a.81.81 0 0 1 .85.55.798.798 0 0 1 0 .6 1.08 1.08 0 0 1-.67.49c-.21.066-.43.099-.65.1a2.11 2.11 0 0 1-.5-.06l-.32-.08v1.16l.2.06c.206.052.418.075.63.07.34-.002.677-.056 1-.16a2.51 2.51 0 0 0 1.45-1.07 1.83 1.83 0 0 0 .07-1.5v-.01zm11.94-4.41-.41-1.06-.73.29-1.26-3.26-1.15.44-1.09 4.47.3.79 2.44-.94.5 1.43 1.16-.45-.55-1.43.79-.28zm-3.31.07.46-1.78.54 1.39-1 .39zm13.57-5.59a1.85 1.85 0 0 0-1.56-1.11c-.47-.04-.941.054-1.36.27l-.13.06-.26-.85 2-.94-.5-1.06-2.88 1.37 1 3.14.33-.2a5.26 5.26 0 0 1 .61-.35 1.91 1.91 0 0 1 .82-.22.84.84 0 0 1 .82.52 1 1 0 0 1-.529 1.311l-.021.009a2.287 2.287 0 0 1-.93.22h-.48l.14 1.14h.46a3.23 3.23 0 0 0 1.21-.32 2.451 2.451 0 0 0 1.27-1.31 2.1 2.1 0 0 0-.06-1.68h.05zm-48.2 19.62-1.22.14 1.26 4.21 1.24-.11-1.28-4.24zm12.74-2.14-1.23.2 1.25 4.71 1.18-.21-1.2-4.7zm13-3.24-1.17.37 1.45 4.68 1.17-.36-1.45-4.69zm12.27-4.45-1.14.52 1.65 4.22 1.1-.53-1.61-4.21zm10.23-5.19-1.13.68 1.21 3.66c.35-.23.7-.47 1-.72l-1.08-3.62zm-41.15 16.51-1.23.16.59 2 1.23-.15-.59-2.01zm25.85-6.66-1.14.45.83 2.14 1.14-.45-.83-2.14zm-12.63 3.86-1.19.29.68 2.35 1.19-.27-.68-2.37zm24-9.3c-.35.21-.75.36-1.1.57l.73 2.1c.367-.2.727-.41 1.08-.63l-.71-2.04z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 31.487,
    y1: 64.103,
    x2: 43.157,
    y2: 81.943,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6db922"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#72bc2f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#c)"
    },
    d: "M32.046 17s-2.21-13 11.44-17c0 0 2.27 12-11.44 17z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 26.885,
    y1: 64.977,
    x2: 25.555,
    y2: 75.547,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a9632b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#af7433"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#d)"
    },
    d: "M28.396 17.11s-2.13-6.06-6.16-7.72l4.47-3.28a15.213 15.213 0 0 1 3.54 11.32 3.349 3.349 0 0 1-1.85-.32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.97f48097b2135715caf796b3948bb7a5.svg";
export { ForwardRef as ReactComponent };